import { useMutation, UseMutationOptions } from 'react-query';

import { authApi } from 'src/Services/API';
import { SuccessResponseDto, UpdatePasswordDto } from 'src/Services/API/generated';

export const useUpdatePasswordWithToken = (
  options?: UseMutationOptions<SuccessResponseDto, unknown, UpdatePasswordDto>
) => {
  return useMutation<SuccessResponseDto, unknown, UpdatePasswordDto>(
    'update-password-with-token',
    async data => {
      const response = await authApi.authControllerUpdate(data);
      return response.data;
    },
    options
  );
};
